import React from "react";
import {Button} from "primereact/button";
import {Avatar} from "primereact/avatar";
import {useNavigate} from "react-router-dom";

const PageHeading = ({
                         title,
                         subtitle,
                         back = false,
                         backFunction = null,
                         avatar,
                         loading = false,
                         buttonPosition,

                         isDelete = false,
                         deleteFunction = null,

                         isEdit = false,
                         editFunction = null,
                         isEditText = false,
                         editIcon = "pi pi-pencil",
                         isEditIcon = true,
                         editButtonText,

                         isCreate = false,
                         createFunction = null,
                         isCreateText = false,
                         createIcon = "pi pi-plus",
                         isCreateIcon = true,
                         createButtonText
                     }: {
    title?: string;
    subtitle?: string;
    back?: boolean;
    backFunction?: any;
    create?: string;
    isCreate?: boolean,
    createFunction?: any;
    avatar?: string;
    createIcon?: string,
    isCreateIcon?: boolean,
    loading?: boolean,
    isCreateText?: boolean,
    createButtonText?: string,
    buttonPosition?: string,
    isDelete?: boolean,
    deleteFunction?: any,
    isEdit?: boolean,
    editFunction?: any,

    isEditText?: boolean,
    editIcon?: string,
    isEditIcon?: boolean,
    editButtonText?: string,
}) => {
    // const router = useRouter();
    const navigate = useNavigate();
    return (
        // <div
        //     className="flex flex-column sm:flex-row sm:align-items-center sm:justify-content-between py-4 md:pt-0 gap-0 sm:gap-2 lg:gap-4 surface-border">
            <div className="flex  align-items-center justify-content-between py-4 md:pt-0 gap-0 sm:gap-2 lg:gap-4 surface-border">
            <div className="flex align-items-center md:justify-content-start">
                {back && (
                    <Button
                        type="button"
                        icon="pi pi-chevron-left"
                        text
                        className="p-button-plain md:mr-3"
                        onClick={() => {
                            if (!backFunction) {
                                navigate(-1)
                            } else {
                                backFunction()
                            }
                        }}
                    ></Button>
                )}
                <div className="flex gap-2 align-items-center">
                    {avatar && <Avatar image={avatar} size="large"/>}
                    <div>
                        <span className="block text-800 font-semibold white-space-nowrap text-base sm:text-xl">
                            {title}
                        </span>
                        {subtitle && <p className="text-sm text-600 mt-2">{subtitle}</p>}
                    </div>
                </div>
            </div>
            <div
                className={`w-full flex  ${buttonPosition ? buttonPosition : "justify-content-end "} gap-3`}>
                {/*buttonPosition*/}
                {
                    isCreate && (
                        <Button
                            label={createButtonText}
                            tooltip="Create"
                            icon={`${isCreateIcon && createIcon}`}
                            size="small"
                            outlined
                            text={isCreateText}
                            onClick={createFunction}
                            loading={loading}
                            tooltipOptions={{ position: 'top' }}

                        />
                    )
                }
                {
                    isEdit && (
                        <Button
                            label={editButtonText}
                            tooltip="Edit"
                            icon={`${isEditIcon && editIcon}`}
                            size="small"
                            outlined
                            text={isEditText}
                            onClick={editFunction}
                            loading={loading}
                            tooltipOptions={{ position: 'top' }}
                        />
                    )
                }
                {
                    isDelete && (
                        <Button
                            type="button"
                            tooltip="Delete"
                            tooltipOptions={{position: "top"}}
                            icon="pi pi-trash"
                            severity="danger"
                            outlined
                            size={'small'}
                            onClick={deleteFunction}

                        />
                    )
                }

            </div>
        </div>
    );
};

export default PageHeading;